import cn from 'classnames';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import OrdersApi from '../../../../../API/shipment/orders-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton, ExportExcelFileButton } from '../../../../../components/Basic/Buttons';
import { Switch } from '../../../../../components/Basic/Elements';
import { H2, TextGrey } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import { formFullDateWithSeconds, getProviderNew } from '../../../../../utils';
import styles from './styles.module.scss';

const statuses = ['Излишки', 'Не хватает', 'Не заказано', 'Частичный резерв', 'Резерв']

const OrderTablePopUp = ({ orderId, providerId, providers, listMarkets, clickOk = () => { }, close = () => { } }) => {
  const [orders, setOrders] = useState([]);
  const [ordersFormatted, setOrdersFormatted] = useState([]);

  const [allowCopyName, setAllowCopyName] = useState(false);
  const [isGroupedOrders, setIsGroupedOrders] = useState(false);
  const [dateGroup, setDateGroup] = useState({});
  const [statusFilter, setStatusFilter] = useState(statuses);
  const [isCopyHeader, setIsCopyHeader] = useState(false);
  console.log(statusFilter)
  // const [dateGroup, setDateGroup] = useState('все');


  const tableRef = useRef();
  const textRef = useRef();
  const [copySuccess, setCopySuccess] = useState("");

  const copyToClipboard = (e) => {
    textRef.current.value = null
    let newTable = document.createElement('table');
    console.log()
    newTable.innerHTML = tableRef.current.innerHTML;
    if (isCopyHeader) {
      const header = newTable.querySelector('thead tr')
      textRef.current.value += header.querySelector('.artnumber')?.textContent + '\t'
      textRef.current.value += header.querySelector('.quantity')?.textContent
      allowCopyName && (textRef.current.value += '\t' + header.querySelector('.name')?.textContent)
      textRef.current.value += '\n'
    }
    for (const [i, row] of Object.entries(newTable.querySelector('tbody').children)) {
      textRef.current.value += row.querySelector('.artnumber')?.textContent + '\t'
      textRef.current.value += row.querySelector('.quantity')?.textContent
      allowCopyName && (textRef.current.value += '\t' + row.querySelector('.name')?.textContent)
      textRef.current.value += '\n'
    }

    textRef.current.select();
    document.execCommand("copy");
  };

  const groupedOrders = useMemo(() => {

    return ordersFormatted.filter(order => {
      if (dateGroup.date) return (new Date(order.date).getTime() === new Date(dateGroup.date).getTime() && order.market === dateGroup.market)
      else return true
    })
      .filter(order => statusFilter.includes(order.status))
      .reduce((acc, item, index) => {

        let existsItem = acc.find(exItem => {

          return (exItem.artnumber === item.artnumber)
        })

        acc = acc.filter(exItem => !(exItem.artnumber === item.artnumber))

        if (item.status === 'Нет в наличии') return acc
        // if (!existsItem) acc.push({ ...item, markets: [item.market] })
        if (!existsItem) acc.push(item)
        else {
          console.log(existsItem)
          acc.push({
            ...item,
            quantity: item.quantity + existsItem.quantity,
            // markets: [...existsItem.markets, item.market]
          })
        }
        return acc
      }, [])
      // .map(i => ({ ...i, markets: _.uniq(i.markets).sort().join(' / ') }))
      .map(i => ({ ...i, quantity: dateGroup.date ? i.quantity : i.quantity - i.ordered })).filter(op => op.artnumber).sort((a, b) => b.quantity - a.quantity).filter(op => op.quantity > 0)

  }, [
    isGroupedOrders,
    dateGroup,
    ordersFormatted
  ])

  const getColor = (p) => {
    let statusColor
    switch (p.status) {
      case 'Резерв': statusColor = '#00cc3d46'; break
      case 'Отправлен заказ': statusColor = '#fef6ae52'; break
      case 'Заказано': statusColor = 'springgreen'; break
      case 'Не заказано': statusColor = '#feaeae41'; break
      case 'Нет в наличии': statusColor = '#ff515198'; break
      case 'Не хватает': statusColor = 'yellow'; break
      case 'Частичный резерв': statusColor = '#b1e32759'; break
      case 'Излишки': statusColor = '#b78eed56'; break
    }
    return statusColor
  }

  const getColorMarket = (market) => {
    let marketColor
    switch (market) {
      case 'wb': marketColor = '#4e004edb'; break
      case 'yandex': marketColor = '#4e4b00fe'; break
      case 'ozon': marketColor = '#000f7fff'; break
    }
    return marketColor
  }

  const formOrderFunc = async () => {
    const ordersData = await OrdersApi.formOrder({ data: { orderId, providerId, listMarkets: listMarkets.value } }).then(r => r.order)
    setOrders(ordersData)
    setOrdersFormatted(ordersData)
  }

  useEffect(() => {
    formOrderFunc()
    return () => { }
  }, []);

  useEffect(() => {
    setOrdersFormatted(orders.filter(order => !order.artnumber || statusFilter.includes(order.status)))
    return () => { }
  }, [statusFilter]);

  let counter = 1
  return (
    <PopUp style={{ minWidth: '1300px', minHeight: '40vh' }} close={close} clickOutside={true}>
      <textarea
        ref={textRef}
        style={{ opacity: 0, position: "absolute", top: "-200px" }}
      ></textarea>
      <H2 style={{ marginBottom: '20px' }}>
        Список заказов {getProviderNew(providerId, providers)?.name} {dateGroup.date ? ` / Выгрузка ${moment(dateGroup.date).format('DD.MM.YYYY HH:mm')} ${dateGroup.market}` : ''}
      </H2>

      <Row style={{ margin: '0px 0px 20px 0px' }}>
        <TextGrey style={{ marginRight: '10px' }}>Копировать наименование</TextGrey>
        <Switch switched={allowCopyName} onClick={(v) => setAllowCopyName(v)} />
        <TextGrey style={{ margin: '0px 10px 0px 20px' }}>Группировать</TextGrey>
        <Switch switched={isGroupedOrders} onClick={(v) => {
          setIsGroupedOrders(v)
          if (!v) setDateGroup({})
        }
        } />
        <Button
          type={TYPE_BUTTONS.GREEN}
          style={{
            marginLeft: '25px',
            height: '28px',
            // width: '100px',
          }}
          disabled={!isGroupedOrders}
          onClick={copyToClipboard}>Скопировать</Button>
        <CheckButton
          style={{ marginLeft: '5px', }}
          checked={isCopyHeader}
          onSelect={() => {
            setIsCopyHeader(!isCopyHeader)
          }}
        />
        <Row style={{ marginLeft: '60px', }}>
          {
            (statuses.map(status => {
              return (
                <Row key={status} style={{ cursor: 'pointer', marginLeft: '15px' }} onClick={() => {
                  setStatusFilter(statusFilter.includes(status) ? statusFilter.filter(s => s !== status) : [...statusFilter, status])
                  // setBillNumber('');
                  // setIsAutoFillBill(!isAutoFillBill)
                }}
                >
                  <CheckButton
                    checked={statusFilter.includes(status)}
                    onSelect={() => {
                      setStatusFilter(statusFilter.includes(status) ? statusFilter.filter(s => s !== status) : [...statusFilter, status])
                    }}
                  />
                  <div style={{ color: 'gray', marginLeft: '5px', font: '12px' }}>{status}</div>
                </Row>
              )
            }))
          }
        </Row>

      </Row>

      <div style={{
        overflowY: 'auto',
        padding: '30px 0',
        maxHeight: '60vh',
        width: '100%'
      }}>

        <table ref={tableRef} className={styles.table_stat}>
          <thead>
            <tr>
              <th className={cn(styles.no_select)} style={{ padding: '0px 10px' }} >№</th>
              {/* <th className={styles.no_select} style={{ padding: '0px 8px' }}>Площадка</th> */}
              <th className='artnumber'>Артикул</th>
              <th className='quantity'>Количество</th>
              <th className={cn('name', !allowCopyName && styles.no_select)}>Наименование</th>
              <th className={styles.no_select}>Стаутс</th>
              {/* <th className={styles.no_select}>Заказан</th> */}
            </tr>
          </thead>
          <tbody>
            {
              (isGroupedOrders ? groupedOrders : ordersFormatted).map((p) => {

                return (
                  // style={{ backgroundColor: getColorStatCondition({ ordered: p.ordered, all: p.all, reserved: p.reserved }), padding: '5px', border: '0.5px solid gray' }
                  <tr
                    key={p.rowNumber}
                    className={cn(!p.artnumber && styles.empty)}
                    style={{ backgroundColor: getColor(p) }}
                  >
                    {p.artnumber ?
                      <>
                        <td
                          className={cn(styles.no_select)}
                          style={{ padding: '0px 10px', backgroundColor: '#eeeeeeff' }}
                        >{counter++}</td>
                        {/* <td
                          style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', padding: '0px 8px', color: getColorMarket(p.markets || p.market) }}
                          className={styles.no_select}
                        >{p.markets || p.market}</td> */}
                        <td
                          className='artnumber'
                        >{p.artnumber}</td>
                        <td
                          className='quantity'
                        >{p.quantity}</td>
                        <td style={{ maxWidth: '600px' }} className={cn('name', !allowCopyName && styles.no_select)}>{p.artnumber ? p.name : formFullDateWithSeconds(p.name)}</td>
                        <td className={cn(styles.no_select)}>{`${p.status} ( ${p.stat_quantity?.reserved ? p.stat_quantity?.reserved + ' +' : ''}  ${p.stat_quantity?.ordered} / ${p.stat_quantity?.need})`}</td>
                      </>
                      :
                      <td
                        colSpan="5"
                        style={{ textAlign: 'center', fontWeight: 'bold' }}
                        className={cn(styles.no_select, styles.date)}
                        onClick={() => {
                          console.log('asdasd');
                          setDateGroup({ date: new Date(p.name), market: p.market })
                          setIsGroupedOrders(true)
                        }}
                      >
                        {`${moment(new Date(p.name)).format('DD.MM.YYYY HH:mm')} ${p.market.toUpperCase()}`}
                      </td>
                    }

                  </tr>
                )
              })}
          </tbody>
        </table>

      </div>

      <Row
        style={{ marginTop: '30px' }}>
        <ExportExcelFileButton
          style={{ marginRight: '20px', ...(!isGroupedOrders && { pointerEvents: 'none', opacity: '0.6' }) }}
          sheets={['Список']}
          columnWidth={[{ wch: 20 }, { wch: 50 }, { wch: 10 }]}
          filename={`Заказ ${getProviderNew(providerId, providers).name} ${moment(new Date()).format('DD.MM.YYYY')}`}
          data={{
            Список: groupedOrders.map(p => ({
              'Артикул': p.artnumber,
              ...(allowCopyName && { 'Наименование': p.name }),
              'Количество': p.quantity,

            })),
          }}
          buttonTitle="Скачать список"
        />
        {/* <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            // marginRight: '15px',
          }}
        // disabled={selectShipment === null || selectOrder === null}
        // onClick={() => clickOk(selectShipment.id, selectOrder?.id)}
        >
          Да
        </Button> */}
        <Button
          type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default OrderTablePopUp;
